// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".symbol.user-avatar,.symbol.user-avatar .symbol-label{-webkit-transition:all .3s ease-out;transition:all .3s ease-out}.symbol.user-avatar:hover{-webkit-transform:scale(1.1);transform:scale(1.1)}.card-custom.no-flip-card:hover,.card.no-flip-card:hover,.no-flip-card:hover{transform:none!important;-webkit-transform:none!important;-webkit-box-shadow:0 0 30px 0 rgba(82,63,105,.05)!important;box-shadow:0 0 30px 0 rgba(82,63,105,.05)!important}", ""]);
// Exports
module.exports = exports;
